import { BreakpointObserver } from '@angular/cdk/layout';
import { Injectable, signal, WritableSignal } from '@angular/core';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BreakpointService {
  isMobileSize: WritableSignal<boolean> = signal<boolean>(false);
  isTabletSize: WritableSignal<boolean> = signal<boolean>(false);
  isDesktopSize: WritableSignal<boolean> = signal<boolean>(false);
  mobileSize = ['(max-width: 600px)'];
  tabletSize = ['(max-width: 1439px)'];
  desktopSize = ['(min-width: 1440px)'];

  constructor(private breakpointObserver: BreakpointObserver) {
    this.setObserverState(this.mobileSize, this.isMobileSize);
    this.setObserverState(this.tabletSize, this.isTabletSize);
    this.setObserverState(this.desktopSize, this.isDesktopSize);
  }

  setObserverState(state: string[], stateMatcher: WritableSignal<boolean>): void {
    this.breakpointObserver.observe(state).pipe(map((result) => result.matches)).subscribe({
      next: (matches) => {
        stateMatcher.set(matches);
      },
    });
  }
}
